module.exports = __webpack_public_path__ + "static/flags/VT-b8b30f8e0c033aceb9da536c5d0d6cc4.gif";